function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#info_svg__clip0)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 0c5.523 0 10 4.478 10 10 0 5.523-4.477 10-10 10S0 15.523 0 10C0 4.478 4.477 0 10 0zm0 18.001a8 8 0 10-.001-16A8 8 0 0010 18v.001zM9.948 5.532h.105a.884.884 0 01.885.884v.012a.885.885 0 01-.885.885h-.105a.885.885 0 01-.885-.885v-.012a.884.884 0 01.885-.884zm.038 3.625h.029a.923.923 0 01.923.923V14c0 .51-.442 1-.952 1s-.923-.49-.923-1v-3.92c0-.51.413-.923.923-.923z",
  fill: "currentColor"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "info_svg__clip0"
}, React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h20v20H0z"
})));

var SvgInfo = function SvgInfo(props) {
  return React.createElement("svg", _extends({
    fill: "none",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDApIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwIDBjNS41MjMgMCAxMCA0LjQ3OCAxMCAxMCAwIDUuNTIzLTQuNDc3IDEwLTEwIDEwUzAgMTUuNTIzIDAgMTBDMCA0LjQ3OCA0LjQ3NyAwIDEwIDB6bTAgMTguMDAxYTggOCAwIDEwLS4wMDEtMTZBOCA4IDAgMDAxMCAxOHYuMDAxek05Ljk0OCA1LjUzMmguMTA1YS44ODQuODg0IDAgMDEuODg1Ljg4NHYuMDEyYS44ODUuODg1IDAgMDEtLjg4NS44ODVoLS4xMDVhLjg4NS44ODUgMCAwMS0uODg1LS44ODV2LS4wMTJhLjg4NC44ODQgMCAwMS44ODUtLjg4NHptLjAzOCAzLjYyNWguMDI5YS45MjMuOTIzIDAgMDEuOTIzLjkyM1YxNGMwIC41MS0uNDQyIDEtLjk1MiAxcy0uOTIzLS40OS0uOTIzLTF2LTMuOTJjMC0uNTEuNDEzLS45MjMuOTIzLS45MjN6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L2c+CiAgPGRlZnM+CiAgICA8Y2xpcFBhdGggaWQ9ImNsaXAwIj4KICAgICAgPHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNMCAwaDIwdjIwSDB6Ii8+CiAgICA8L2NsaXBQYXRoPgogIDwvZGVmcz4KPC9zdmc+Cg==";
export { SvgInfo as ReactComponent };